module.exports = __webpack_public_path__ + "static/media/logo-white.41f65f75.png";